import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/404/NotFoundPage'
import {Container} from 'react-bootstrap'
import MenuOperator from '../components/menus/menu-operator'
import Dashboard from '../pages/operator/Dashboard'
import Input from '../pages/operator/Input'
import Counter from '../pages/operator/Counter'

export default function OperatorRouter () {   
    return (
        <Container className='cabecera'>
            <MenuOperator/>        
            <Routes>
                <Route path="/dashboard" element={<Dashboard/>}/>
                <Route path="/input" element={<Input/>}/>
                <Route path="/counters" element={<Counter/>}/>
                <Route path="*" element={<NotFoundPage />}/>
            </Routes>
        </Container>
    )
}